/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from "react";
import Container from "../../components/Container/Container";
import Table from "../../components/Table/Table";
import { API, STATIC, ROUTER } from "../../constants/env";
import swal from "sweetalert";

import ModalSeeMore from "./ModalSeeMore";
function ListUsers() {
  const fields = [
    { title: "Photo", field: "picture" },
    { title: "Prénom", field: "firstName" },
    { title: "Nom", field: "lastName" },
    { title: "Phone", field: "phone" },
    { title: "Address", field: "adress" },
    { title: "Voir Plus", field: "seeMore" },
  ];
  const [data, setData] = useState([]);
  const fetchData = (currentPage, count, search, setTotalPage, setTotal) => {
    fetch(
      API.parents.list +
        `?page=${currentPage}&count=${count}&searchQuery=${search}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }

        console.log(response.data);
        const result = response.data.map((elem) => ({
          _id: elem._id,
          picture: (
            <img
              alt="parent_pic"
              src={STATIC.ROUTE(elem.profil.picture)}
              className="rounded imgWidthThumbnail"
            />
          ),
          firstName: elem.profil.firstName,
          lastName: elem.profil.lastName,
          phone: elem.profil.phone,
          adress: elem.profil.adress,
          seeMore: <ModalSeeMore id={elem._id} />,
        }));
        setData(result);
        setTotalPage(response.totalPage);
        setTotal(response.total);
      })
      .catch((e) => {});
  };

  return (
    <Container
      name="Liste des parents"
      actionRoute={ROUTER.PARENTS.CREATE}
      actionName="Ajouter un parent"
    >
      <Table
        pageName="par"
        name="Les parents"
        fields={fields}
        data={data}
        editRoute={(id) => ROUTER.PARENTS.EDIT(id)}
        deleteApiRoute={API.parents.remove}
        deleteMultiple={API.parents.deleteMultiple}
        fetchData={fetchData}
        showSearch={true}
      />
    </Container>
  );
}

export default ListUsers;
